(function () {
    'use strict';

    angular.module("imApp").factory("vtsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3796,
                    parameters: parms || {}
                });
            },
            importVtFromDisc: function () {
                return $ihttp.post({
                    method: 3798,
                    parameters: {}
                });
            },
        };

        return service;
    }]);
})();

